/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type BlockListItem_block$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type BlockList_viewer$ref: FragmentReference;
export type BlockList_viewer = {|
  +blocks: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +$fragmentRefs: BlockListItem_block$ref
      |}
    |}>
  |},
  +$refType: BlockList_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BlockList_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "blocks",
      "name": "blocks",
      "storageKey": null,
      "args": null,
      "concreteType": "BlockConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "BlockEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Block",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "BlockListItem_block",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd048899b867b7fe9902875c32f2e58b6';
module.exports = node;



// WEBPACK FOOTER //
// src/components/blocks/__generated__/BlockList_viewer.graphql.js